import React, { useState } from "react";
import { Modal, ModalBody } from "reactstrap";
import { AccessConfiguration } from "../../AccessConfiguration/AccessConfiguration";

import style from "./FirstAccessModal.scss";

export const FirstAccessModal = ({ approved, handleAuthorize }) => {
  return (
    <Modal size="lg" isOpen contentClassName={style.content}>
      <ModalBody>
        <AccessConfiguration approved={approved} handleAuthorize={handleAuthorize} />
      </ModalBody>
    </Modal>
  );
};
